import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { ConnectionBanner } from './ConnectionBanner'
import { HedefLogo } from './HedefLogo'
import { MenuIcon } from './icons'

/**
 * Uygulama kabugunun ISKELETI: ust bar + kenar cubugu + icerik.
 *
 * ## Neden ortak bir bilesen
 *
 * Iki ekran ayni kabugu gosteriyor: sohbet (`ChatScreen`) ve paylasilan
 * sohbet (`SharedScreen`). Kullanici paylasilan gorunumun "kendi sohbet
 * ekranimin tamamiyla ayni" olmasini istedi - tek fark, ustte bunun
 * paylasilmis bir sohbet oldugunu soyleyen serit.
 *
 * Iki ekranin kabugunu ayri ayri yazmak, ikisinin zamanla AYRISMASI
 * demekti: sohbet ekranina eklenen her yenilik paylasilan gorunumde
 * eksik kalirdi ve bunu kimse fark etmezdi (iki ekran da "calisiyor"
 * gorunur).
 *
 * ## Durum DISARIDA
 *
 * `drawerOpen` bu bilesende tutulmuyor. Sohbet ekraninda cekmece
 * kisayollarla (`useShortcuts`) da aciliyor ve `Esc` sirasi paletle
 * birlikte yonetiliyor; durumu buraya tasimak o sirayi ikiye bolerdi.
 * Kabuk yalnizca DOM ve CSS iskeletini paylasiyor.
 */
export function AppShell({
  banner,
  headerExtra,
  headerActions,
  sidebar,
  drawerOpen,
  onToggleDrawer,
  onCloseDrawer,
  children,
}: {
  /** Ust barin USTUNDE duran serit (paylasilan gorunumde dolu). */
  banner?: ReactNode
  /** Markanin yaninda duran ek (paylasimda sohbetin basligi). */
  headerExtra?: ReactNode
  /** Ust barin sagi: bildirim, yonetim, profil - ya da giris daveti. */
  headerActions?: ReactNode
  sidebar: ReactNode
  drawerOpen: boolean
  onToggleDrawer(): void
  onCloseDrawer(): void
  children: ReactNode
}) {
  const { t } = useTranslation()
  return (
    <div className={drawerOpen ? 'app app-drawer-open' : 'app'}>
      {banner}
      <header className="app-header">
        <span className="header-left">
          {/* Mobilde sidebar kayan panel; masaustunde bu buton gizli. */}
          <button
            type="button"
            className="btn-drawer"
            onClick={onToggleDrawer}
            aria-expanded={drawerOpen}
            aria-label={t('chat.header.toggleSidebar')}
          >
            <MenuIcon />
          </button>
          <span className="brand" aria-label={t('chat.sidebar.brand')}>
            <HedefLogo height={20} />
          </span>
          {headerExtra}
        </span>
        <span className="header-right">{headerActions}</span>
      </header>

      {/*
        Baglanti banner'i header'in ALTINDA ve icerigin USTUNDE: kullanici
        yanit beklerken oraya bakiyor. Sayfa dibinde olsa gorulmezdi.
      */}
      <ConnectionBanner />

      <div className="app-body">
        {sidebar}
        {/*
          Mobilde panel acikken arkaya tiklamak paneli kapatiyor. Gercek bir
          `<button>`: klavye ve ekran okuyucu icin de erisilebilir olmali,
          tiklanabilir bir `<div>` degil.
        */}
        {drawerOpen && (
          <button
            type="button"
            className="drawer-scrim"
            onClick={onCloseDrawer}
            aria-label={t('chat.header.closeSidebar')}
          />
        )}
        {children}
      </div>
    </div>
  )
}
